// import USER from '../../api/user'
// import router from '../../router/index'
// import { setToken, removeToken, getToken, setCookie, getCookie } from '../../common/auth'
// console.log(router.options.routes.filter(ele=>{
//     return (ele.role ===0 || ele.role === -1)
// }));
import USER from '@/api/user'

const state = {
    routers: [],
    uname: '',
    isLogin: false,
    storeInfo: {
        Name: ''
    },
};
const getters = {

};
const mutations = {
    SET_LOGIN: (state, isLogined) => {
        state.isLogin = isLogined;
    },
    SET_USER_INFO: (state) => {
        USER.getLoginerInfo().then(res => {
            if (res.status === 'success') {
                state.isLogin = true;
                if (res.content.storeInfo != null) {
                    state.storeInfo = res.content.storeInfo;
                }
                state.uname = res.content.name;
                state.routers = res.content.routers;
            }
        })
    }
};
const actions = {
    // getPowerRouter({ state }) {
    //     if (Array.isArray(state.routers) && state.routers.length > 0) {
    //         return state.routers;
    //     } else {
    //         USER.getRouter().then(res => {
    //             if (res.status === "success") {
    //                 state.routers = res.content;
    //             } else {
    //                 router.push('/login')//路由生成失败的话，返回重新登录
    //             }
    //         })
    //     }
    // }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}